<template>
  <v-container class="pa-0">
    <!-- Platform and Content Type Selection -->
    <v-row class="mb-4" align="center" dense>
      <v-col cols="3" v-for="platform in platforms" :key="platform.name">
        <v-select
          v-model="selectedOptions[platform.name]"
          :items="platform.options"
          label="Select options"
          variant="outlined"
          density="compact"
          multiple
          chips
          style="min-width: 140px"
          :menu-props="{ maxWidth: '20rem', minWidth: '680rem' }"
        >
          <template #prepend-inner>
            <v-avatar size="20" class="me-2">
              <v-img :src="platform.icon" />
            </v-avatar>
          </template>
        </v-select>
      </v-col>
    </v-row>
    <!-- Customize by platform -->
    <v-switch
      v-model="customizeByPlatform"
      label="Customize by platform"
      color="teal-darken-4"
      hide-details
      inset
      density="compact"
      class="my-custom-switch"
    />
  </v-container>
</template>

<script setup>
import { ref } from "vue";

// Post text and other fields
const customizeByPlatform = ref(false);
const postText = ref("");
const image = ref(
  "https://cdn.pixabay.com/photo/2016/11/29/12/54/aurora-1868523_1280.jpg"
);
const scheduleTime = ref("");
const boost = ref(false);

// Platform options
const facebook_option = ["Post", "Reel"];
const Instagram_option = ["Post", "Reel", "Story"];
const x_option = ["Post", "Reel", "Story"];
const TikTok_option = ["Post", "Reel", "Story"];

const platforms = [
  {
    name: "Facebook",
    icon: require("@/assets/images/icons/facebook.svg"),
    options: facebook_option,
  },
  {
    name: "Instagram",
    icon: "https://cdn-icons-png.flaticon.com/512/2111/2111463.png",
    options: Instagram_option,
  },
  {
    name: "LinkedIn",
    icon: "https://cdn-icons-png.flaticon.com/512/145/145807.png",
    options: x_option,
  },
  {
    name: "TikTok",
    icon: "https://cdn-icons-png.flaticon.com/512/3046/3046121.png",
    options: TikTok_option,
  },
];

// Selected options for each platform
const selectedOptions = ref({
  Facebook: [],
  Instagram: [],
  LinkedIn: [],
  TikTok: [],
});
</script>

<style scoped>
.v-textarea textarea {
  resize: none !important;
}
textarea {
  overflow: auto !important;
}
.v-chip--variant-tonal .v-chip__underlay {
  background: rgb(57 216 219);
}
.v-chip__content {
  color: #000;
}
.my-custom-switch .v-input--switch__track {
  height: 20px;
  border-radius: 10px;
}
.v-switch--inset .v-switch__track {
  border-radius: 9999px;
  font-size: 0.75rem;
  height: 1rem !important;
  min-width: 3.2rem !important;
}
.my-custom-switch .v-input--switch__thumb {
  width: 20px;
  height: 20px;
}
</style>
